var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lazy-image',{attrs:{"src":_vm.img_src,"lazy_src":_vm.lazy_img_src,"alt":"Slide image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }